import React, { useState, useCallback } from "react";
import { ThemeProvider } from "styled-components";
import ColumnSelector from "./ColumnSelector";
import { v4 as uuid } from "uuid";
import isEmpty from "lodash/isEmpty";
import { injectIntl } from "react-intl";
import SettingsDropDown from "./SettingsDropDown";
import {
  RowStyled,
  LeftCol,
  Empty,
  HeaderColumn,
  Bottom,
  IconWrapper,
  SettingsIcon,
  AddRowIcon,
  DeleteWrapper,
  Top,
} from "./styles";

const Row = injectIntl((props) => {
  const {
    id,
    select,
    extra = {},
    componentsConfig,
    add,
    remove,
    nodes,
    fb3Add,
    fb3ClickMoveRowStart,
    fb3Copy,
    fb3Remove,
    intl,
    parentId,
  } = props;
  const { style = {}, css } = extra;
  const [hover, setHover] = useState(false);
  const [hoverDelete, setHoverDelete] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const setRowColumnConfig = useCallback(({ colConfig }) => {
    const rowNode = nodes[id];
    const { structure = [] } = rowNode;

    let numberOfColumns = structure.length;

    for (let j = structure.length - 1; j >= 0; j--) {
      if (numberOfColumns <= colConfig.length) {
        break;
      }

      const colComp = nodes[structure[j]];
      if (isEmpty(colComp.structure)) {
        numberOfColumns--;
        fb3Remove({ id: structure[j], parentId: id });
      }
    }

    colConfig.forEach((colMD, i) => {
      if (structure[i]) {
        props.save({ _id: structure[i], name: "cols", value: colMD });
      } else {
        const colComp = componentsConfig["Col"];
        const colCompId = uuid();
        const colComponent = {
          ...colComp,
          _id: colCompId,
          extra: {
            ...colComp.defaultExtra,
            cols: colMD,
          },
        };

        fb3Add({ component: colComponent, parent: id });
      }
    });
  });

  return (
    <ThemeProvider theme={style}>
      <RowStyled
        className="row"
        hover={hoverDelete}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-id={id}
        inlineCSS={css}
      >
        <LeftCol hover={hover}>
          {true && (
            <>
              <Top>
                <IconWrapper
                  data-tip={intl.formatMessage({ id: "fb3.RowOptions" })}
                  onClick={() => setSettingsOpen(!settingsOpen)}
                  role="button"
                  aria-label="Row more options"
                >
                  <SettingsIcon className="fal fa-ellipsis-v" />
                  {settingsOpen && (
                    <SettingsDropDown
                      setOpen={setSettingsOpen}
                      setHoverDelete={setHoverDelete}
                      add={add}
                      moveRowStart={fb3ClickMoveRowStart}
                      id={id}
                      parentId={parentId}
                      remove={remove}
                      copy={fb3Copy}
                    />
                  )}
                </IconWrapper>
                <IconWrapper
                  data-tip={intl.formatMessage({ id: "fb3.RowSettings" })}
                  data-position="center"
                  data-id={id}
                  data-parentid={parentId}
                  onClick={select}
                  role="button"
                  aria-label="Row settings"
                >
                  <AddRowIcon className="fal fa-cog" />
                </IconWrapper>
              </Top>
              <Bottom>
                <div data-tip={intl.formatMessage({ id: "fb3.AddRow" })}>
                  <IconWrapper
                    data-name="Row"
                    data-type="sibling"
                    data-parentid={id}
                    onClick={add}
                    role="button"
                    aria-label="Add row"
                  >
                    <AddRowIcon className="fal fa-arrow-to-bottom" />
                  </IconWrapper>
                </div>
              </Bottom>
            </>
          )}
        </LeftCol>
        {
          <HeaderColumn className="col-md-12">
            <ColumnSelector
              setRowColumnConfig={setRowColumnConfig}
              node={nodes[id]}
              nodes={nodes}
            />
          </HeaderColumn>
        }
        {props.children}

        {!props.children && <Empty />}

        {hoverDelete && <DeleteWrapper></DeleteWrapper>}
      </RowStyled>
    </ThemeProvider>
  );
});

export default Row;
